import React, { useCallback } from 'react';
import { Form, Table, Typography } from '../../../../components';
import { Container } from '../../../../layouts';

const Dimensions = (props) => {
  const fields = [
    { id: 'length.gage', label: 'Gage Length' },
    { id: 'length.matrix', label: 'Matrix Length' },
    { id: 'length.overall', label: 'Overall Length' },
    { id: 'width.grid', label: 'Grid Width' },
    { id: 'width.matrix', label: 'Matrix Width' },
    { id: 'width.overall', label: 'Overall Width' },
  ];

  const renderRow = useCallback(
    (unit) => {
      const row = { unit };
      fields.forEach((field) => {
        row[field.id] = (
          <Form.TextField
            id={`${field.id}_${unit}`}
            name={`dimensions.${field.id}_${unit}`}
            onChange={props.formik.handleChange}
            disabled={props.disabled}
            value={
              props.formik.values.dimensions[field.id.split('.')[0]][
                `${field.id.split('.')[1]}_${unit}`
              ]
            }
            variant="standard"
          />
        );
      });
      return row;
    },
    [props.formik, fields]
  );

  return (
    <Container className={props.className} disableGutters>
      <Typography variant="h6">Dimensions</Typography>
      <Form.Groupbox>
        <Table
          size="small"
          columns={[{ id: 'unit' }, ...fields]}
          rows={['inch', 'mm'].map((unit) => {
            return renderRow(unit);
          })}
          keyField="unit"
        />
      </Form.Groupbox>
    </Container>
  );
};

export default Dimensions;
